var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectricVehicles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Electric-Car-Charge--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Electric Car Charge Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.7 7.646 13.973 0.079A0.897 0.897 0 0 1 14.046 0v6.336h2.445c0.351 0 0.664 0.445 0.319 0.873l-6.278 7.574a0.99 0.99 0 0 1 -0.079 0.08V8.532H8.008c-0.194 0 -0.29 -0.048 -0.335 -0.08a0.286 0.286 0 0 1 -0.105 -0.154c-0.055 -0.171 -0.022 -0.44 0.132 -0.652Zm6.484 5.077 -2.511 3.03 -0.006 0.006c-0.45 0.518 -1.108 0.848 -1.778 0.6 -0.648 -0.241 -0.933 -0.89 -0.933 -1.49v-2.146H4.461a341.983 341.983 0 0 1 1.313 -2.8l0.178 -0.375 0.049 -0.103 0.012 -0.026 0.003 -0.007 0.001 -0.002 -0.903 -0.43 0.903 0.43a1 1 0 1 0 -1.806 -0.858l0.903 0.429 -0.903 -0.43 0 0.001 -0.001 0.002 -0.004 0.007 -0.012 0.027 -0.05 0.103 -0.178 0.377 -0.582 1.234c-0.392 0.835 -0.845 1.804 -1.154 2.485a2.752 2.752 0 0 0 -2.156 2.68v3.793c0 0.47 0.16 0.918 0.494 1.252a1.6 1.6 0 0 0 0.205 0.174v1.069C0.773 22.966 1.807 24 3.018 24c1.212 0 2.246 -1.034 2.246 -2.245v-0.749h13.472v0.749c0 1.211 1.034 2.245 2.246 2.245 1.211 0 2.245 -1.034 2.245 -2.245v-1.07c0.072 -0.05 0.14 -0.108 0.205 -0.173 0.334 -0.334 0.494 -0.783 0.494 -1.252v-3.793c0 -1.31 -0.928 -2.412 -2.16 -2.681l-1.974 -4.228a1 1 0 1 0 -1.812 0.846l1.549 3.32h-5.345Zm4.552 4.142a1.148 1.148 0 1 1 2.296 0 1.148 1.148 0 0 1 -2.296 0Zm-15.767 0a1.148 1.148 0 1 1 2.295 0 1.148 1.148 0 0 1 -2.295 0Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectricVehicles);
export default ForwardRef;